import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import { api, useAPIContext } from '../../api/context';
import { Title } from '../../utils/title';
import toast from '../../utils/toast';
import socials from '../../utils/socials';
import Layout from './Layout';
import styles from './_04_Socials.module.scss';

const KEY = 'tiktok';

const _04_Socials = () => {

  const { token } = useAPIContext();
  const [ loading, setLoading ] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {

    api(token).v1.socials.query()
      .then(res => {
        setLoading(false);

        if (res.body.data[KEY]) {
          navigate('/campaigns');
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  }, [token, navigate]);

  const connect = () => {

    setLoading(true);

    api(token).v1.socials
      .post(
        { provider: KEY },
        { target: window.location.href },
      )
      .then(res => {
        if (res.status === 200) {
          window.location.href = res.body.url;
        } else {
          setLoading(false);
        }
      })
      .catch(err => {
        setLoading(false);
        toast.show(toast.KIND.WARNING, err);
      });

  };

  return (
    <>
      <Title value='Socials' />
      <Layout step='socials' auth={true}>
        <div className={styles.root}>

          <LazyLoadImage
            alt={socials.ITEM[KEY].label}
            src={socials.ITEM[KEY].image}
          />

          <button
            type='button'
            onClick={() => connect()}
            disabled={loading}>

            Connect

          </button>

        </div>
      </Layout>
    </>
  );
};

export default _04_Socials;